import disease  from './medical/disease'
import diseases from './medical/diseases'

const medical =
{
    disease,
    diseases
};

export default medical ;